import { Trans } from "react-i18next";
import React from "react";

export default class LicenseValidityEnum {
    transform(value) {
        if (_.isEmpty(value)) {
            return null;
        }
        const translationPrefix = "dhb.license.validity";
        const label = translationPrefix + "." + value.toLowerCase();
        const expired = value === "expired";

        return (
            <div style={expired ? { color: "red" } : { color: "green" }}>
                <Trans>{label}</Trans>
            </div>
        );
    }
}
